<template>

    <vs-tabs v-model="active_tab" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'System' : ''" @click="tabsClickSetting('UserSettingsGeneral','/settings')">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Personal' : ''"  @click="tabsClickSetting('UserSettingsNotifications','/settings?setting=personal')" >
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
      </vs-tab>
<!--      v-if="hasPermission('Setting.Web.edit')"-->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Bill Setting' : ''" @click="tabsClickSetting('UserSettingsConnections','/settings?setting=web-setting')" >
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <transition name="slide-fade" mode="out-in">
            <component :is="componentCurrent" @changeTab="changeTab"/>
          </transition>
        </div>
      </vs-tab>
    </vs-tabs>

</template>

<script>
import UserSettingsGeneral from './UserSettingsGeneral.vue'
import UserSettingsChangePassword from './system/ManegUser.vue'
import UserSettingsInfo from './system/AccountPayment.vue'
import UserSettingsSocialLinks from './UserSettingsSocialLinks.vue'
import UserSettingsConnections from './UserSettingsConnections.vue'
import UserSettingsNotifications from './UserSettingsNotifications.vue'
import GroupPermission from './system/GroupPermisionTitle.vue'
import CustomField from './system/PracticeArea.vue'
import Recovery from './system/Recovery.vue'
import Security from './system/Security.vue'
import Plans from './system/Plans.vue'
import Documents from './system/Documents.vue'
import AggregateReporting from './system/AggregateReporting.vue'
import Profile from './profile/Profile.vue'
import Apps from './profile/Apps.vue'
import TextSnippets from './profile/TextSnippets.vue'
import FirmPreferences from './settings/FirmPreferences.vue'
import DataEscrow from './settings/dataEscrow.vue'
import FirmFeed from './settings/FirmFeed.vue'
import ConnectSharing from './settings/ConnectSharing.vue'
import Billing from './settings/Billing.vue'
import TaxSetting from './settings/TaxSetting.vue'
import Notifications from './profile/Notifications.vue'
import mixin from '@/views/mixin/mixin'

export default {
  mixins:[mixin],
  components: {
    UserSettingsGeneral,
    UserSettingsChangePassword,
    UserSettingsInfo,
    UserSettingsSocialLinks,
    UserSettingsConnections,
    UserSettingsNotifications,
    GroupPermission,
    CustomField,
    Recovery,
    Security,
    Plans,
    Documents,
    AggregateReporting,
    Profile,
    Apps,
    TextSnippets,
    FirmPreferences,
    DataEscrow,
    FirmFeed,
    ConnectSharing,
    Billing,
    Notifications,
    TaxSetting
  },
  data () {
    return {
      active_tab      : '0',
      componentCurrent: 'UserSettingsGeneral',
      crumbs          : []
    }
  },
  watch:{
    $route(){
      this.activeTab()
    }
  },
  methods:{
    changeTab(val){
      this.componentCurrent = val
    },
    tabsClickSetting(component,url){
      this.componentCurrent = component
      this.$router.push(url).catch(()=>{})
    },
    activeTab(){
      if(this.$route.query.setting === "personal" && !this.$route.query.profile){
        this.componentCurrent = 'UserSettingsNotifications'
        this.active_tab = '1'
      } else if (this.$route.query.setting === 'web-setting'){
        this.componentCurrent = 'UserSettingsConnections'
        this.active_tab = '2'
      }else if(this.$route.query.setting === 'billing'){
        this.componentCurrent = 'Billing'
        this.active_tab = '2'
      }else if(this.$route.query.setting === 'account'){
        this.componentCurrent = 'UserSettingsInfo'
        this.active_tab = '0'
      }else if(this.$route.query.setting === 'ntf'){
        this.componentCurrent = 'TextSnippets'
        this.active_tab = '1'
      } else if(this.$route.query.setting === "personal" && this.$route.query.profile === "profile"){
        this.componentCurrent = 'Profile'
        this.active_tab = '1'
      }else if(this.$route.query.plan_id || this.$route.query.hasOwnProperty('plan_id')){
        this.componentCurrent = 'Plans'
        this.active_tab = '0'
      } else{
        this.componentCurrent = 'UserSettingsGeneral'
        this.active_tab = '0'
      }
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  created() {
    this.activeTab()
    console.log(this.active_tab,'this.active_tab')
    if(!localStorage.getItem("accessToken")){
      this.$router.push('/pages/login')
    }
  }
}
</script>

<style>

   #profile-tabs .vs-tabs--content {
      padding: 0;
    }

   .slide-fade-enter-active {
     opacity: 1;
     transition: all .3s ease;
   }
   .slide-fade-leave-active {
     transition: all .3s ease-in-out;
   /*cubic-bezier(1.0, 0.5, 0.8, 1.0)*/
   }
   .slide-fade-enter, .slide-fade-leave-to {
     transform: translateX(50px);
     opacity: 0;
   }
   @media (min-width: 960px) {
     .mobile_crumb{
       position: absolute;
       top: 15%;
       left:11%
     }
   }

</style>
